import { For } from 'solid-js'
import { getRewardTreeAssets } from '~/lib/reward-tree-assets'

export function PrizeCol(props: { gids: number[]; label: string }) {
  return (
    <div class="flex flex-col items-center gap-2">
      <div class="flex max-w-[120px] flex-wrap items-center justify-center gap-1">
        <For each={props.gids}>
          {(gid) => {
            const src = getRewardTreeAssets(gid).full
            return (
              <span class="grid size-[34px] shrink-0 place-items-center rounded-full bg-white shadow-[0_1px_2px_rgba(80,40,10,0.08)]">
                <img
                  src={src}
                  alt=""
                  aria-hidden="true"
                  class="size-7 object-contain"
                />
              </span>
            )
          }}
        </For>
      </div>
      <p class="whitespace-normal text-center text-[12px] font-semibold leading-snug text-bakery-brown-deep">
        {props.label}
      </p>
    </div>
  )
}
